<template>
    <div class="Footer">
    <footer>
        <div class="container">
        <div class="media p-5  text-left sm-text-center ">
          <div class="col-sm-9 ">
              <p class="neka">Copyright © 2018 DEMO, All rights Reserved.</p>
          </div>
          <div class="col-sm-3 ">
            <img class="mx-1 my-1" src="../assets/img/fb.png" alt="facebook">
            <img class="mx-1 my-1" src="../assets/img/tw.png" alt="twitter">
            <img class="mx-1 my-1" src="../assets/img/pin.png" alt="pinterest">
          </div>
      </div>
    </div>
  </footer>
        
    </div>
</template>

<script>
export default {
  name: 'Footer',
  
}

</script>

<style scoped>

@import '../style.css';

footer {
    background-color: #13253B;
    color:#FFF;
    height: 200px;
    display: flex;
    align-items: center;
}

.media {
  margin: 0;
  display: flex;
  align-items: center;
}

.neka {
  margin: 0;
}


</style>